var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, } from "react";
import { UserContext } from "../Context/UserContext";
import { FormContext } from "../Context/FormContext";
import styled from "styled-components";
import useApiCall from "../Hooks/useApiCall";
import * as Endpoint from "../../Http";
import { useHistory } from "react-router";
import { FlashMessageContext, } from "../Context/FlashMessageContext";
import Button from "../atoms/Button";
import LogoutIcon from "../atoms/icons/LogoutIcon";
const StyledButton = styled.button ``;
const StyledLogoutIcon = styled(LogoutIcon) `
    width: 24px !important;
    height: 18px !important;
`;
const Logout = (_a) => {
    var { children, buttonText, isTextButton } = _a, restProps = __rest(_a, ["children", "buttonText", "isTextButton"]);
    const history = useHistory();
    const { user, setUser } = useContext(UserContext);
    const { dirty } = useContext(FormContext);
    const { flashMessage, setFlashMessage } = useContext(FlashMessageContext);
    const [logout, , , loading] = useApiCall("post", Endpoint.LOGOUT);
    const logoutHandler = (e) => {
        e.preventDefault();
        if (loading) {
            return;
        }
        if (dirty &&
            !window.confirm("Let op, de niet-opgeslagen gegevens in deze stap gaan verloren als u uitlogt. Rond eerst deze stap af om de gegevens te bewaren in dit formulier.")) {
            return;
        }
        logout().then(() => {
            setUser(null);
            setFlashMessage({
                type: "success",
                message: "U bent succesvol uitgelogd",
            });
            history.push("login");
        });
    };
    return (React.createElement(React.Fragment, null, isTextButton ? (React.createElement(Button, Object.assign({ onClick: logoutHandler, buttonIcon: React.createElement(StyledLogoutIcon, null) }, restProps), buttonText)) : (React.createElement(StyledButton, Object.assign({ type: "button", onClick: logoutHandler }, restProps), children))));
};
export default Logout;
